// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseSetupDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import fetch from 'share/fetch/Izenda.Fetch';
import uiState from 'logic/Izenda.UiState';
import { isEmpty, isNil, isArray } from 'lodash/fp';
const ROOT_URL = 'NLQ/';
const ROOT_REPORT_URL = 'report/';
export default {
  /**
   * Load query source's columns
   * @param {Object} SearchedString
   * @param {Object} IsTobeSearch
   * @param {Object} dict
   */
  suggestResult(SearchedString: any, IsTobeSearch: any, dict: any,tenantId:string): Promise {

    const requestData = {
        SearchedString: SearchedString,
        IsTobeSearch: IsTobeSearch,
        dict:dict,
        tenantId : isEmpty(tenantId) ? '' : tenantId
    };

    return fetch(`${ROOT_URL}ProcessNLQ`).post(requestData);
  },
/**
   * get visualization data and schema
   * @param {any} data
   * @returns {promise}
   */
  getreportPartVisualization(data: any): Promise {
    return fetch(`${ROOT_URL}reportPartVisualization`).post(data);
  },

    /**
   * Load all report Categories
   * @param  {Object} data [description]
   * @return {Promise}      [description]
   */
  getALLReports(data, includeHashCode) {
    let url = 'list2';
    url += !isNil(includeHashCode) ? `?includeHashCode=${includeHashCode}` : '';
    return fetch(ROOT_REPORT_URL + url).post(data);
  }
};


// WEBPACK FOOTER //
// ./ui/fetchers/Izenda.ExploreFetcher.js